(function () {
    // Check if the current URL ends with '.html' and is not the root '/'
    if (window.location.pathname.endsWith('.html') && window.location.pathname !== '/') {
      // Construct a new URL without the '.html' extension
      var newUrl = window.location.pathname.slice(0, -5) + window.location.search + window.location.hash;
      
      // Redirect if the new URL differs from the current one
      if (newUrl !== window.location.pathname) {
        window.location.replace(newUrl);
      }
    }
    
    // Check for URLs ending with a trailing slash '/'
    if (window.location.pathname.endsWith('/') && window.location.pathname !== '/') {
      // Construct a new URL without the trailing slash
      var newUrl = window.location.pathname.slice(0, -1) + window.location.search + window.location.hash;
      // Redirect if the new URL differs from the current one
      if (newUrl !== window.location.pathname) {
        window.location.replace(newUrl);
      }
    }
    
    // Check for URLs containing two or more consecutive slashes '//'
    if (window.location.pathname.includes('//')) {
      // Replace multiple consecutive slashes with a single slash
      var newUrl = window.location.pathname.replace(/\/{2,}/g, '/') + window.location.search + window.location.hash;
      // Redirect if the new URL differs from the current one
      if (newUrl !== window.location.pathname) {
        window.location.replace(newUrl);
      }
    }
    
    // Check for URLs with different cases in path segments
    if (window.location.pathname !== window.location.pathname.toLowerCase()) {
      // Convert the path to lowercase
      var newUrl = window.location.pathname.toLowerCase() + window.location.search + window.location.hash;
      // Redirect if the new URL differs from the current one
      if (newUrl !== window.location.pathname) {
        window.location.replace(newUrl);
      }
    }
    
    // Redirect to the homepage if the URL contains '/index'
    if (window.location.pathname.toLowerCase().indexOf('/index') !== -1) {
      // Construct a new URL without '/index'
      var newUrl = window.location.origin + window.location.pathname.replace(/\/index/gi, '') + window.location.search + window.location.hash;
      
      // Redirect to the new URL
      window.location.replace(newUrl);
    }
})();